import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=3b6e257d"
import script from "./PageBuilder.vue?vue&type=script&lang=js"
export * from "./PageBuilder.vue?vue&type=script&lang=js"
import style0 from "./PageBuilder.vue?vue&type=style&index=0&id=3b6e257d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports